import { Toast } from "react-bootstrap";

function ToastComponent({ message, show, onClose }) {
  return (
    <Toast
      className="rounded-bottom pb-2 top-end border-0"
      show={show}
      onClose={onClose}
    >
      <Toast.Header className="fw-medium w-100 pb-2 d-flex justify-content-between">
        <span>{message}</span>
      </Toast.Header>
    </Toast>
  );
}

export default ToastComponent;
